import React, { useState, useEffect } from 'react';
import { ToastContainer, Toast } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import CommonModal from './CommonModal';

const DeleteToast = ({
  sentData,
  onEvent,
  onConfirm,
  apiPath,
  axios,
  columnName,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [t] = useTranslation();

  useEffect(() => {
    if (sentData && onEvent) {
      setShowModal(true);
    }
  }, [sentData, onEvent]);

  const handleCloseModal = () => {
    setShowModal(false);
    onEvent({ open: false, sentData: null });
  };

  const toggleStatus = async (sentData) => {
    try {
      await axios
        .delete(`/api/${apiPath}/${sentData.id}`, {
          withCredentials: true,
        })
        .then((resp) => {
          setShowModal(false);
          setShowToaster(true);
          onConfirm(); // Call onConfirm to update the list
        })
        .catch((error) => {
          console.error('Error toggling status:', error);
        });
    } catch (err) {
      console.error('Error toggling status:', err);
    }
  };

  return (
    <>
      <CommonModal
        open={showModal}
        message={`Are you sure you want to delete ${sentData?.[columnName]}?`}
        buttonProps={[
          {
            label: 'Cancel',
            onClick: handleCloseModal,
          },
          {
            label: 'Confirm',
            onClick: () => toggleStatus(sentData),
          },
        ]}
        hideHeader
        id="hideHeader"
      />

      <ToastContainer className="p-3" position="top-end" style={{ zIndex: 1 }}>
        <Toast
          animation={true}
          autohide={true}
          delay={5000}
          show={showToaster}
          onClose={() => setShowToaster(false)}
          className="d-inline-block m-1"
          bg="success"
          key="success"
        >
          <Toast.Header>
            <FontAwesomeIcon icon={faCheck} style={{ color: '#198754' }} />{' '}
            &nbsp; <div className="me-auto">Record deleted successfully</div>
          </Toast.Header>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default DeleteToast;
